module.exports = __webpack_public_path__ + "img/economicsGreen.220aad0a.png";